import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

import { DataGrid } from "@mui/x-data-grid";
import br from "date-fns/locale/pt-BR";

export default function AcompanhamentoCargaItensModalDetalhe(
  props: AcompanhamentoCargaItensModalDetalhePropsTypes
) {

  return (
    <>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterlocale={br}>
        <div className="divFlow">
          <div style={{ height: "50vh", width: "100%" }}>
            <DataGrid
              rows={props.data}
              columns={props.columns}
              rowsPerPageOptions={[50, 100, 250, 500]}
            />
          </div>
        </div>
      </LocalizationProvider>
    </>
  );
}

interface AcompanhamentoCargaItensModalDetalhePropsTypes {
  handleClose: any;
  data: any;
  columns: any;
}
